import React from 'react';

var ElementsHeaderBg = function ElementsHeaderBg() {
  return /*#__PURE__*/React.createElement("div", {
    className: "elements"
  }, /*#__PURE__*/React.createElement("div", {
    className: "elements-bg elements-bg--top"
  }), /*#__PURE__*/React.createElement("div", {
    className: "elements-bg elements-bg--bottom"
  }));
};

ElementsHeaderBg.displayName = "ElementsHeaderBg";
export default ElementsHeaderBg;